const Content1 = () => {
    return(
        <div className="gradient">
            <h5 className="content1Terms white-text fw-bold fs-30 m-fs-18 lh-160 text-center">Term Conditions</h5>
        </div>
    )
}

export default Content1